import { useEffect, useState } from "react";
import {
  LoadExternalScript,
  LoadInlineScript,
  properties,
} from "../common/properties";

export const useHeaderScripts = (
  headerScript: HTMLScriptElement[]
): boolean => {
  const [scriptsReady, setScriptsReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setScriptsReady(false);

    const runScripts = async () => {
      for (const script of headerScript) {
        try {
          const scriptSrc = script.getAttribute("src") as string;
          if (scriptSrc) {
            await LoadExternalScript(
              scriptSrc.startsWith("https")
                ? scriptSrc
                : properties.aemBaseUrl + scriptSrc
            );
          } else {
            LoadInlineScript(script.innerHTML);
          }
        } catch (e) {
          console.error("Failed to execute header script", e);
        }
      }
      if (!cancelled) setScriptsReady(true);
    };

    runScripts();

    return () => {
      cancelled = true;
    };
  }, [headerScript]);

  return scriptsReady;
};
